<!-- 评价管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexColumn">
        <div class="head-title borderB">
          <div class="text">评价管理</div>
        </div>
        <div class="headSearch Fs14">
          <div class="headSearch-left">
            <div class="Search-condition">
              <div class="form-data group">
                <span>手机号码：</span>
                <el-input
                  clearable
                  v-model="SearchForm.tel"
                  size="mini"
                  placeholder=""
                ></el-input>
              </div>
              <div class="form-data group">
                <el-button
                  @click="GetIndentList"
                  round
                  type="primary"
                  size="mini"
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-table
          height="72vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="IndentList.list"
          style="width: 100%"
        >
          <el-table-column prop="outTradeNo" label="订单号"> </el-table-column>
          <el-table-column prop="name" label="订单用户"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column prop="indentprice" label="金额"> </el-table-column>
          <el-table-column label="服务人员" width="120">
            <template>
              {{ '接口暂无' }}
            </template>
          </el-table-column>
          <el-table-column prop="indentname" label="商品名"> </el-table-column>
          <el-table-column label="订单时间">
            <template slot-scope="scope">
              {{ scope.row.dingdanshijian | filterTime }}
            </template>
          </el-table-column>
          <el-table-column prop="message" label="评价"> </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                style="padding-left:10px"
                @confirm="delBut(scope.row)"
                title="删除后无法找回，确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ IndentList.total }}条记录，</span>
            <span class="pageNum">{{ IndentList.pageNum }}</span>
            <span>/{{ IndentList.pages }}页</span>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="IndentList.pageNum"
            :page-size="IndentList.pageSize"
            layout="prev, pager, next, jumper"
            :total="IndentList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetIndentList, apiDelMessage } from '@/api/orderManage'

export default {
  name: '',
  props: [''],
  data() {
    return {
      IndentList: '', // 列表
      SearchForm: {
        tel: ''
      },
      pages: {
        page: 1, // 页数
        size: 20
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetIndentList()
  },

  methods: {
    // 删除
    delBut(row) {
      console.log(row)
      apiDelMessage({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetIndentList()
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetIndentList()
    },
    // 接口
    // 获取订单列表/评价管理
    GetIndentList() {
      apiGetIndentList({
        tel: this.SearchForm.tel,
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.IndentList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .headSearch {
      width: 100%;
      .headSearch-left {
        padding-top: 10px;
        .form-data {
          // span {
          //   width: 90px;
          // }
          .el-cascader {
            width: 200px;
          }
          /deep/ .el-date-picker {
            width: 200px;
          }
          /deep/ .el-date-editor {
            width: 506px;
          }
          /deep/ .el-input,
          .el-select {
            width: 200px;
          }
        }
      }
    }
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
